export const SHARE_VIEWS = ['people', 'log'] as const;

export type ShareView = (typeof SHARE_VIEWS)[number];

/** `?share=people` or `?share=log` on an account page opens its share panel on that view. */
export const SHARE_PANEL_PARAM = 'share';

export function getSharePanelSearch(view: ShareView): string {
  return `?${new URLSearchParams({[SHARE_PANEL_PARAM]: view}).toString()}`;
}

export function isShareView(value: string | null): value is ShareView {
  return (SHARE_VIEWS as readonly (string | null)[]).includes(value);
}
